export default __webpack_public_path__ + "static/media/egranting-nanme.abb55051.png";